import CalibrationRoadmap from "./CalibrationRoadmap";
import Close from "./Close";
import Handoff from "./Handoff";
import Interview from "./Interview";
import Intro from "./Intro";
import PFQuiz from "./PFQuiz";
import PracticeQuiz from "./PracticeQuiz";
import ProgrammingAssignment from "./ProgrammingAssignment";
import Read from "./Read";
import Recalibration from "./Recalibration";
import Waiting from "./Waiting";

export const viewComponents = {
    interview: Interview,
    roadmap: CalibrationRoadmap,
    reading: Read,
    close: Close,
    intro: Intro,
    practice_quiz: PracticeQuiz,
    pf_quiz: PFQuiz,
    programming: ProgrammingAssignment,
    waiting: Waiting,
    recalibration: Recalibration,
    handoff: Handoff,
};
